// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgConnectionIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="m11.81 14.29 4 2c-.43.52-.7 1.15-.77 1.85l-4.12-2.06c.41-.52.72-1.13.9-1.79Zm-.64-4.04 2.55-2.55c-.62-.3-1.12-.8-1.41-1.41L9.76 8.84c.56.37 1.04.85 1.41 1.41m-.74.73c-.34-.58-.83-1.07-1.41-1.41C8.43 9.22 7.74 9 7 9c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.2 0 2.27-.54 3-1.38.44-.5.76-1.11.91-1.78q.09-.405.09-.84c0-.74-.21-1.43-.57-2.02m4.06-4.05c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51.18.69.72 1.23 1.41 1.41ZM18.5 16a2.493 2.493 0 0 0-2.5 2.5c0 .04.01.08.01.12.07 1.32 1.15 2.38 2.49 2.38s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5" />
  </Icon>
);
export default SvgConnectionIcon;
SvgConnectionIcon.displayName = 'SvgConnectionIcon';
